<template>
  <div>
    <line-chart v-if="!loading" :curve="true" :data="data"></line-chart>
  </div>
</template>

<script>
  import { HalfCircleSpinner } from 'epic-spinners'
  import { HTTP } from '../../http.js'

  export default {
    name: 'loading',
    props: ['nodeId', 'capability'],
    components: {
      HalfCircleSpinner
    },
    data: () => ({
      loading: false,
      data: []
    }),
    created () {
      this.laddaGraf()
    },
    destroyed () {},
    methods: {
      laddaGraf () {
        // Leta upp noden samt capabilityn så vi kan döpa dem korrekt
        const node = this.$root.data.nodes.find(node => node.id === this.nodeId)
        const cap = this.$root.capabilities[this.capability]
        
        let point = {
          name: node.name + ' / ' + cap.name,
          id: this.nodeId + '-' + this.capability
        }
  
        let whereArray = []
  
        whereArray.push('(name=\'' + this.capability + '\')')
        whereArray.push('sourceNode=' + this.nodeId)        
                  
        this.loading = true
        HTTP.get('eventlog?where=' + whereArray.join(' and '))
        .then(res => res.data)
        .then(json => {
          point.data = json.map(item => {
            return [
              item.time,
              item.value
            ]
          })
  
          this.loading = false
          this.data.push(point)
        })
      }
    },
    computed: {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/graphViewForNode.vue